// UX-телеметрия внутренних кабинетов (ADR-0046).
//
// Внутренние кабинеты (фотограф/ведущая, dev-отдел, история) логируют действия
// пользователя: открытия, вкладки, экраны и время на них, съёмку и её итоги,
// скачивания печати. Цель — видеть реальные паттерны пользования и чинить UX
// по данным, а не по ощущениям (правило владельца, 2026-08-07).
//
// Принципы: НЕЗАМЕТНО для рабочего флоу (батчи, keepalive, ошибки молча),
// append-only журнал, детали — компактный JSON без байтов и без токенов.
import { z } from 'zod';

export const UxEventSchema = z.object({
  /** Что произошло: app_open, tab, screen, capture_start, capture_result,
   *  print_queue_open, print_download, click, app_hide, app_show, … —
   *  словарь открытый, анализ идёт по факту. */
  event: z.string().trim().min(1).max(64),
  /** Где: cabinet | devdept | history | camera | …  */
  surface: z.string().trim().max(32).default(''),
  /** Компактные детали события (JSON-строка). Без PII сверх аккаунта. */
  detail: z.string().max(1000).default(''),
  /** Время на клиенте, ISO. Серверное время пишется отдельно. */
  client_ts: z.string().trim().max(40).default(''),
  /** Случайный id вкладки/сессии — склеивает события одного захода. */
  session_id: z.string().trim().max(64).default(''),
});
export type UxEvent = z.infer<typeof UxEventSchema>;

export const WorkUxReqSchema = z.object({
  events: z.array(UxEventSchema).min(1).max(100),
});
export type WorkUxReq = z.infer<typeof WorkUxReqSchema>;

export const WorkUxResSchema = z.object({ ok: z.boolean() });
export type WorkUxRes = z.infer<typeof WorkUxResSchema>;
